import React from 'react';
import { CTAButton } from './CTAButton';
import { ZapIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-neutral-950 text-white pt-0 pb-16 md:pb-24 overflow-hidden" data-id="element-126">
      {/* Urgency Banner */}
      <div className="w-full bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base tracking-wide flex items-center justify-center gap-2" data-id="element-127">
        <ZapIcon className="w-5 h-5 animate-pulse" data-id="element-128" />
        <span data-id="element-129">92% DISCOUNT EXPIRES TODAY — Only for the first 50 buyers</span>
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-12 md:pt-20 text-center relative z-10" data-id="element-130">
        <div className="inline-block border border-amber-500/30 bg-amber-500/10 text-amber-500 font-bold tracking-widest uppercase text-xs md:text-sm px-4 py-2 rounded-full mb-8" data-id="element-131">
          The 2026 Vitality Bundle: Men's Health 40+
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-132">
          <span className="block text-gray-400 text-2xl md:text-3xl lg:text-4xl mb-4 font-medium tracking-normal" data-id="element-133">
            [The Executive Biological Reset Protocol]
          </span>
          Reclaim Your Edge.
        </h1>

        <p className="text-xl md:text-2xl text-gray-400 mb-10 md:mb-14 max-w-3xl mx-auto leading-relaxed" data-id="element-134">
          The "Hidden" Reason You're Tired, Foggy, and Losing Your Edge... and
          the 15-minute daily protocol to fix it.
        </p>

        <div className="mb-10 md:mb-14" data-id="element-135">
          <img src="https://cdn.magicpatterns.com/uploads/v45pAsVqPEKvFNXo2oAMJy/Book_cover.png" alt="The 40+ Vitality Code Bundle — Book, Dopamine Pro Guide, Libido Restoration Guide, and 5-Minute Grocery List" className="w-full max-w-2xl mx-auto rounded-2xl shadow-[0_0_60px_rgba(245,158,11,0.15)]" data-id="element-136" />
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-137">
          <CTAButton text="YES! GET THE VITALITY BUNDLE" className="w-full md:w-auto min-w-[320px]" data-id="element-138" />
          <div className="flex items-center gap-2 text-gray-400 text-sm mt-2" data-id="element-139">
            <ClockIcon className="w-4 h-4" data-id="element-140" />
            <span data-id="element-141">Instant Digital Access. No Physical Shipping Required.</span>
          </div>
        </div>
      </div>

      {/* Background Gradient Effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-142"></div>
    </section>;
}